const collectionFields = new Set(['familyDependents', 'educationHistories', 'workExperiences', 'certificates', 'skills']);

const normalizeValue = (value: unknown): string | number => {
  if (value === undefined || value === null) return '';
  if (typeof value === 'number') return value;
  if (Array.isArray(value)) {
    return JSON.stringify(value.map((item) =>
      typeof item === 'object' && item !== null
        ? Object.keys(item).sort().reduce((result, key) => {
            result[key] = (item as Record<string, unknown>)[key];
            return result;
          }, {} as Record<string, unknown>)
        : item,
    ));
  }
  return String(value).trim();
};

/** Chỉ gửi danh sách khi người dùng đã sửa nó trong form. */
export const buildUserUpdatePayload = (
  newData: Record<string, unknown>,
  originalData: Record<string, unknown>,
  editedCollections: ReadonlySet<string>,
): Record<string, unknown> => {
  const updateData: Record<string, unknown> = {};

  for (const [key, value] of Object.entries(newData)) {
    if (collectionFields.has(key) && !editedCollections.has(key)) continue;

    const newValue = normalizeValue(value);
    const oldValue = normalizeValue(originalData[key]);
    if (newValue !== oldValue && (newValue !== '' || oldValue !== '')) {
      // undefined không được gửi qua JSON; null biểu thị thao tác xóa trường.
      updateData[key] = value === undefined ? null : value;
    }
  }

  return JSON.parse(JSON.stringify(updateData)) as Record<string, unknown>;
};
